import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ijxucjdebjcgbknlltab.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqeHVjamRlYmpjZ2JrbmxsdGFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ3Mzg4NzcsImV4cCI6MjEwMDMxNDg3N30.r_dOy07kNoxfBZ7PxbU5B4XG0-dKH4xmDqHSJ1VMB60'

if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseKey)

// Database types
export interface Review {
    id: number
    name: string
    rating: number
    comment: string
    location: string
    countrycode: string
    date: string
    created_at: string
    approved: boolean
}
